import { appiq } from './appiq';
import { jobaffairs } from './jobaffairs';
import { jobiq } from './jobiq';
import { lead } from './lead';
import { recruitingiq } from './recruitingiq';
import { stellencockpit } from './stellencockpit';
import type { Brand, BrandKey } from './types';

export const brands: Record<BrandKey, Brand> = { lead, appiq, jobiq, stellencockpit, recruitingiq, jobaffairs };
